// extracted by mini-css-extract-plugin
module.exports = {"container":"log-details-screen_container_2RBRt","screen":"log-details-screen_screen_2jOZv"};